import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Container,
  Row,
  Col,
  Form,
  Card,
  InputGroup,
  Spinner,
} from "react-bootstrap";
import Select from "react-select";
import { addVendor } from "../../store/slices/vendor";
import { emailregex, mobileregex } from "../../utils/Regex";
import { toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";
import { getPlace } from "../../store/slices/place";

const stateOptions = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",

  // Union Territories
  "Andaman and Nicobar Islands",
  "Chandigarh",
  "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi",
  "Jammu and Kashmir",
  "Ladakh",
  "Lakshadweep",
  "Puducherry",
];

export default function AddVendor() {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { placeList = [] } = useSelector((state) => state.place);

  const fetchplacedata = () => {
    try {
      dispatch(getPlace());
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchplacedata();
  }, []);

  const serviceOptions = [
    { value: "HOTEL", label: "Hotel" },
    { value: "VEHICLE", label: "Vehicle" },
    { value: "ACTIVITY", label: "Activity" },
    { value: "FERRY", label: "Ferry" },
  ];

  const initialform = {
    name: "",
    contactPerson: "",
    mobileNumber: "",
    email: "",
    address: "",
    city: "",
    state: "",
    country: "",
    pincode: "",
    gstNumber: "",
    panNumber: "",
    creditDays: "",
    paymentTerms: "",
    notes: "",
    location: "",
    category: "",
    checkInTime: "",
    checkOutTime: "",
    bankDetails: {
      accountName: "",
      accountNumber: "",
      ifscCode: "",
      bankName: "",
      branch: "",
    },
  };

  const [form, setForm] = useState(initialform);

  const [service, setService] = useState([]);

  const [errors, setErrors] = useState({});

  const [submitloading, setsubmitLoading] = useState(false);

  const isHotelSelected = service.includes("HOTEL");

  const handleChange = (e) => {
    const { name, value } = e.target;

    let updatedValue = value;
    let error = "";

    if (["gstNumber", "panNumber"].includes(name)) {
      updatedValue = value.toUpperCase();
    }

    const gstRegex =
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

    // Company Name
    if (name === "name") {
      if (!updatedValue.trim()) {
        error = "Please enter company name";
      } else if (!/^[a-zA-Z0-9][\s\S]*$/.test(updatedValue)) {
        error = "Please enter letters first";
      }
    }

    // contactperson

    if (name === "contactPerson") {
      if (!updatedValue.trim()) {
        error = "Please enter contact person name";
      } else if (!/^[A-Za-z'\s]+$/.test(updatedValue)) {
        error = "Contact person must contain letters only";
      }
    }

    // mobilenumber

    if (name === "mobileNumber") {
      if (!updatedValue.trim()) {
        error = "Please enter mobile number";
      } else if (!mobileregex.test(updatedValue)) {
        error = "Enter valid 10-digit mobile number";
      }
    }

    // emails
    if (name === "email") {
      const value = updatedValue;

      if (!value.trim()) {
        error = "Please enter email";
      } else if (value.includes(" ")) {
        error = "Email should not contain spaces";
      } else if (value.includes("*")) {
        error = "Masked email is not allowed";
      } else if (!emailregex.test(value)) {
        error = "Please enter valid email";
      } else {
        error = "";
      }
    }

    if (name === "pincode") {
      if (!/^\d{6}$/.test(updatedValue)) error = "Pincode must be 6 digits";
    }

    if (name === "service") {
      if (!value) {
        error = "Please select service";
      }
    }

    if (name === "address") {
      if (!updatedValue.trim()) {
        error = "Please enter address";
      }
    }

    if (name === "city") {
      if (!updatedValue.trim()) {
        error = "Please enter city";
      }
    }

    if (name === "location") {
      if (!updatedValue.trim()) {
        error = "Please select location";
      }
    }

    if (name === "category") {
      if (!updatedValue.trim()) {
        error = "Please select category";
      }
    }

    if (name === "checkInTime") {
      if (!updatedValue.trim()) {
        error = "Please select checkin time ";
      }
    }

    if (name === "checkOutTime") {
      if (!updatedValue.trim()) {
        error = "Please select checkout time ";
      }
    }

    if (name === "state") {
      if (!updatedValue.trim()) {
        error = "Please select state";
      }
    }

    if (name === "country") {
      if (!updatedValue.trim()) {
        error = "Please enter country";
      }
    }

    if (name === "gstNumber") {
      if (updatedValue && !gstRegex.test(updatedValue)) {
        error = "Invalid GST Number";
      }
    }

    if (name === "panNumber") {
      if (updatedValue && !panRegex.test(updatedValue)) {
        error = "Invalid PAN Number";
      }
    }

    setForm((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const handleBankChange = (e) => {
    const { name, value } = e.target;

    let updatedValue = value;

    if (name === "ifscCode") {
      updatedValue = value.toUpperCase();
    }

    setForm((prev) => ({
      ...prev,
      bankDetails: {
        ...prev.bankDetails,
        [name]: updatedValue,
      },
    }));

    validateBankField(name, updatedValue);
  };

  const validateBankField = (name, value) => {
    let error = "";
    const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;

    if (name === "accountName") {
      if (value && !/^[A-Za-z\s.&]+$/.test(value)) {
        error = "Account name must contain letters only";
      }
    }

    if (name === "accountNumber") {
      if (value && !/^\d+$/.test(value)) {
        error = "Account number must be numeric";
      }
    }

    if (name === "ifscCode") {
      if (value && !ifscRegex.test(value)) {
        error = "Invalid IFSC Code";
      }
    }

    if (name === "bankName") {
      if (value && !/^[A-Za-z\s]+$/.test(value)) {
        error = "Bank name must contain letters only";
      }
    }

    if (name === "branch") {
      if (value && !/^[A-Za-z\s]+$/.test(value)) {
        error = "Branch must contain letters only";
      }
    }

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const validate = () => {
    let newErrors = {};

    const gstRegex =
      /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;

    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

    const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;

    /* ================= REQUIRED FIELDS ================= */

    if (!form.name.trim()) newErrors.name = "Please enter company name";

    if (!form.contactPerson.trim())
      newErrors.contactPerson = "Please enter contact person";

    if (!mobileregex.test(form.mobileNumber))
      newErrors.mobileNumber = "Please enter valid mobile number";

    if (!emailregex.test(form.email))
      newErrors.email = "Please enter valid email";

    if (!form.address.trim()) newErrors.address = "Please enter address";

    if (!form.city.trim()) newErrors.city = "Please enter city";
    if (!form.location.trim()) newErrors.location = "Please select locality";

    if (!form.state.trim()) newErrors.state = "Please select state";
    if (service.includes("HOTEL")) {
      if (!form.checkInTime.trim())
        newErrors.checkInTime = "Please enter checkin time";

      if (!form.checkOutTime.trim())
        newErrors.checkOutTime = "Please enter checkout time";

      if (!form.category) newErrors.category = "Please select star rating";
    }

    if (!form.country.trim()) newErrors.country = "Please enter country";

    if (!/^\d{6}$/.test(form.pincode))
      newErrors.pincode = "Pincode must be 6 digits";

    if (!service.length) newErrors.service = "Please select service";

    /* ================= OPTIONAL FIELDS (FORMAT ONLY) ================= */

    // GST (optional but valid format)
    if (form.gstNumber.trim() && !gstRegex.test(form.gstNumber)) {
      newErrors.gstNumber = "Invalid GST Number";
    }

    // PAN (optional but valid format)
    if (form.panNumber.trim() && !panRegex.test(form.panNumber)) {
      newErrors.panNumber = "Invalid PAN Number";
    }

    // Credit Days (optional but numeric)
    if (form.creditDays.trim() && !/^\d+$/.test(form.creditDays)) {
      newErrors.creditDays = "Credit Days must be numeric";
    }

    /* ================= BANK GROUP VALIDATION ================= */

    const { accountName, accountNumber, ifscCode, bankName, branch } =
      form.bankDetails;

    // Check if any bank field is filled
    const isAnyBankFieldFilled =
      accountName.trim() ||
      accountNumber.trim() ||
      ifscCode.trim() ||
      bankName.trim() ||
      branch.trim();

    if (isAnyBankFieldFilled) {
      if (!accountName.trim())
        newErrors.accountName = "Account name is required";

      if (!accountNumber.trim())
        newErrors.accountNumber = "Account number is required";

      if (!ifscCode.trim()) newErrors.ifscCode = "IFSC Code is required";

      if (!bankName.trim()) newErrors.bankName = "Bank name is required";

      if (!branch.trim()) newErrors.branch = "Branch name is required";
    }
    // Account Name (optional)
    if (
      form.bankDetails.accountName.trim() &&
      !/^[A-Za-z\s.&]+$/.test(form.bankDetails.accountName)
    ) {
      newErrors.accountName = "Account name must contain letters only";
    }

    // Account Number (optional)
    if (
      form.bankDetails.accountNumber.trim() &&
      !/^\d+$/.test(form.bankDetails.accountNumber)
    ) {
      newErrors.accountNumber = "Account number must be numeric";
    }

    // IFSC (optional)
    if (
      form.bankDetails.ifscCode.trim() &&
      !ifscRegex.test(form.bankDetails.ifscCode)
    ) {
      newErrors.ifscCode = "Invalid IFSC Code";
    }

    // Bank Name (optional)
    if (
      form.bankDetails.bankName.trim() &&
      !/^[A-Za-z\s]+$/.test(form.bankDetails.bankName)
    ) {
      newErrors.bankName = "Bank name must contain letters only";
    }

    // Branch (optional)
    if (
      form.bankDetails.branch.trim() &&
      !/^[A-Za-z\s]+$/.test(form.bankDetails.branch)
    ) {
      newErrors.branch = "Branch must contain letters only";
    }

    // Notes
    if (form.notes && form.notes.length > 200) {
      newErrors.notes = "Maximum 200 characters allowed";
    }

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setsubmitLoading(true);

    try {
      const payload = {
        ...form,
        services: service,
      };

      await dispatch(addVendor(payload)).unwrap();

      toast.success("Service provider added successfully");

      navigate("/admin/vendor");

      setForm(initialform);
      setErrors({});
    } catch (error) {
      toast.error(error || "Failed to add service provider");
    } finally {
      setsubmitLoading(false);
    }
  };

  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-bar mb-2">
        <div className="breadcrumb-left">
          <Link to="/admin/home" className="breadcrumb-link active">
            Home
          </Link>

          <span className="breadcrumb-separator">|</span>
          <Link to="/admin/vendor" className="breadcrumb-link active">
            Service Provider
          </Link>

          <span className="breadcrumb-separator">|</span>

          <span className="breadcrumb-link inactive">Add New</span>
        </div>
      </div>
      <Container className="mt-4">
        <Card className="shadow-sm p-4" style={{ border: "none" }}>
          <Card.Body>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Company Name</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="name"
                        placeholder="Enter company name"
                        value={form.name}
                        maxLength={50}
                        onChange={handleChange}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.name}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Contact Person</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="contactPerson"
                        placeholder="Enter contact person name"
                        value={form.contactPerson}
                        onChange={handleChange}
                        maxLength={50}
                      />
                    </InputGroup>
                    <small className="text-danger">
                      {errors.contactPerson}
                    </small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Mobile Number</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="mobileNumber"
                        maxLength={10}
                        placeholder="Enter mobile number"
                        value={form.mobileNumber}
                        onChange={(e) => {
                          if (/^\d*$/.test(e.target.value)) handleChange(e);
                        }}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.mobileNumber}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Email</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="email"
                        placeholder="Enter emaill"
                        value={form.email}
                        onChange={handleChange}
                        maxLength={75}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.email}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Services</Form.Label>

                    <Select
                      isMulti
                      options={serviceOptions}
                      value={serviceOptions.filter((opt) =>
                        service.includes(opt.value),
                      )}
                      onChange={(selectedOptions) => {
                        const values = selectedOptions
                          ? selectedOptions.map((opt) => opt.value)
                          : [];

                        setService(values);

                        setErrors((prev) => ({
                          ...prev,
                          service: "",
                        }));
                      }}
                      placeholder="Select Service"
                    />
                    <small className="text-danger">{errors.service}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Address</Form.Label>
                    <InputGroup>
                      <Form.Control
                    as="textarea"
                        name="address"
                        placeholder="Enter Address"
                        value={form.address}
                        onChange={handleChange}
                        maxLength={500}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.address}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>City</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="city"
                        placeholder="Enter city name"
                        value={form.city}
                        onChange={handleChange}
                        maxLength={30}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.city}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Locality</Form.Label>

                    <Form.Select
                      name="location"
                      value={form.location}
                      onChange={handleChange}
                    >
                      <option value="">Select</option>

                      {placeList?.map((place) => (
                        <option key={place._id} value={place._id}>
                          {place.name}
                        </option>
                      ))}
                    </Form.Select>

                    {errors.location && (
                      <small className="text-danger">{errors.location}</small>
                    )}
                  </Form.Group>
                </Col>
                {isHotelSelected && (
                  <>
                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label>Category</Form.Label>
                        <Form.Select
                          name="category"
                          value={form.category}
                          onChange={handleChange}
                        >
                          <option value="">Select</option>
                          <option>2 Star</option>
                          <option>3 Star</option>
                          <option>4 Star</option>
                          <option>5 Star</option>
                          <option>Home Stay</option>
                          <option>Villa</option>
                          <option>Budget</option>
                        </Form.Select>
                        {errors.category && (
                          <small className="text-danger">
                            {errors.category}
                          </small>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label>Checkin Time</Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            type="time"
                            name="checkInTime"
                            value={form.checkInTime}
                            onChange={handleChange}
                            placeholder="Enter checkin time"
                          />
                        </div>
                        {errors.checkInTime && (
                          <small className="text-danger">
                            {errors.checkInTime}
                          </small>
                        )}
                      </Form.Group>
                    </Col>

                    <Col md={3}>
                      <Form.Group className="mb-3">
                        <Form.Label>Checkout Time</Form.Label>
                        <div className="position-relative">
                          <Form.Control
                            type="time"
                            name="checkOutTime"
                            value={form.checkOutTime}
                            onChange={handleChange}
                            placeholder="Enter checkout time"
                          />
                        </div>
                        {errors.checkOutTime && (
                          <small className="text-danger">
                            {errors.checkOutTime}
                          </small>
                        )}
                      </Form.Group>
                    </Col>
                  </>
                )}

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>State</Form.Label>
                <Select
  options={stateOptions.map((state) => ({
    value: state,
    label: state,
  }))}
  value={
    form.state
      ? { value: form.state, label: form.state }
      : null
  }
  onChange={(selectedOption) => {
    setForm((prev) => ({
      ...prev,
      state: selectedOption ? selectedOption.value : "",
    }));

    setErrors((prev) => ({
      ...prev,
      state: "",
    }));
  }}
  placeholder="Select State"
/>
                    <small className="text-danger">{errors.state}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Country</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="country"
                        placeholder="Enter country name"
                        value={form.country}
                        onChange={handleChange}
                        maxLength={30}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.country}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Pincode</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="pincode"
                        maxLength={6}
                        placeholder="Enter pincode"
                        value={form.pincode}
                        onChange={(e) => {
                          if (/^\d*$/.test(e.target.value)) handleChange(e);
                        }}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.pincode}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>GST Number</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="gstNumber"
                        maxLength={15}
                        placeholder="Enter GST number"
                        value={form.gstNumber}
                        onChange={handleChange}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.gstNumber}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>PAN</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="panNumber"
                        maxLength={10}
                        placeholder="Enter PAN"
                        value={form.panNumber}
                        onChange={handleChange}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.panNumber}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Credit Days</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="creditDays"
                        placeholder="Enter credit days"
                        maxLength={2}
                        value={form.creditDays}
                        onChange={(e) => {
                          if (/^\d*$/.test(e.target.value)) handleChange(e);
                        }}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.creditDays}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Payment Terms</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="paymentTerms"
                        placeholder="Enter payment terms"
                        value={form.paymentTerms}
                        onChange={handleChange}
                        maxLength={60}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.paymentTerms}</small>
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Account Name</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="accountName"
                        placeholder="Enter account name"
                        value={form.bankDetails.accountName}
                        onChange={(e) => {
                          if (/^[A-Za-z\s]*$/.test(e.target.value)) {
                            handleBankChange(e);
                          }
                        }}
                        maxLength={30}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.accountName}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Account Number</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="accountNumber"
                        placeholder="Enter account number"
                        value={form.bankDetails.accountNumber}
                        inputMode="numeric"
                        maxLength={15}
                        onChange={(e) => {
                          if (/^\d*$/.test(e.target.value)) handleBankChange(e);
                        }}
                      />
                    </InputGroup>
                    <small className="text-danger">
                      {errors.accountNumber}
                    </small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>IFSC Code</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="ifscCode"
                        maxLength={11}
                        placeholder="Enter IFSC Code"
                        value={form.bankDetails.ifscCode}
                        onChange={handleBankChange}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.ifscCode}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Bank Name</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="bankName"
                        placeholder="Enter bank name"
                        value={form.bankDetails.bankName}
                        onChange={(e) => {
                          if (/^[A-Za-z\s]*$/.test(e.target.value)) {
                            handleBankChange(e);
                          }
                        }}
                        maxLength={30}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.bankName}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Branch</Form.Label>
                    <InputGroup>
                      <Form.Control
                        type="text"
                        name="branch"
                        placeholder="Enter Branch Name"
                        value={form.bankDetails.branch}
                        onChange={handleBankChange}
                        maxLength={30}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.branch}</small>
                  </Form.Group>
                </Col>

                <Col md={3}>
                  <Form.Group className="mb-3">
                    <Form.Label>Notes</Form.Label>
                    <InputGroup>
                      <Form.Control
                        as="textarea"
                        rows={3}
                        name="notes"
                        placeholder="Enter Notes (Optional)"
                        value={form.notes}
                        onChange={handleChange}
                        maxLength={300}
                      />
                    </InputGroup>
                    <small className="text-danger">{errors.notes}</small>
                  </Form.Group>
                </Col>
              </Row>

              {/* Buttons */}
              <div className="text-center d-flex justify-content-center align-items-center mt-5 mb-5">
                <button
                  type="button"
                  className="cancel-btn me-3"
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="submit-btn d-flex align-items-center justify-content-center"
                  disabled={submitloading}
                >
                  {submitloading ? (
                    <>
                      <Spinner
                        animation="border"
                        size="sm"
                        variant="light"
                        className="me-2"
                      />
                      Submitting...
                    </>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </Container>
    </>
  );
}
